<template>
    <v-app id="app">
        <template v-if="layout">
            <keep-alive>
                <component v-bind:is="layout">
                </component>
            </keep-alive>
        </template>
        <add-to-home enable-undo></add-to-home>
        <v-offline @detected-condition="amIOnline">
        </v-offline>
        <popup-offline :showPopup="appOnLine === false" :success="false">
            <template #title>
                {{ $vuetify.t("$vuetify.App.offlineMessageTitle")}}
            </template>
            {{ $vuetify.t("$vuetify.App.offlineMessage")}}

        </popup-offline>
    </v-app>
</template>

<style lang="scss">
    #app {
        font-family: 'Roboto', Helvetica, Arial, sans-serif;
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #fff;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>


<script>

    //const default_layout = "Application"

    import LoginLayout from "./views/layouts/login"
    import ApplicationLayout from "./views/layouts/application"
    import AddToHome from "./components/AddToHome"
    import VOffline from 'v-offline';
    import PopupOffline from './components/genericPopupResponseStatus'

    export default {
        data() {
            return {
                layout: null,
                appOnLine: null

            }
        },
        components: {
            LoginLayout,
            ApplicationLayout,
            AddToHome,
            VOffline,
            PopupOffline
        },
        watch: {
            "$route.meta.layout": {

                handler: function (newVal) {

                    if(newVal){
                        this.layout = (newVal || "Application") + "Layout"
                    }else{
                        this.layout= null
                    }
                },
                deep: true,
                immediate: true


            }

        },
        methods: {
            amIOnline(e) {
                this.appOnLine = e;
            },
            $_setCssVh(){
                let vh = window.innerHeight * 0.01;
                this.$nextTick(() => {
                    document.documentElement.style.setProperty('--vh', `${vh}px`);

                })
            }
        }

    }
</script>
